// src/SuccessScreen.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export default function SuccessScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center text-center px-6">
      <div className="mb-6">
        <CheckCircle2 size={80} className="text-green-500" />
      </div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Foto Enviada com Sucesso!
      </h1>
      <p className="text-gray-500 mb-8">
        Sua imagem foi validada e registrada.
      </p>

      <div className="w-full max-w-sm space-y-3">
        <button
          onClick={() => navigate('/photo')}
          className="w-full bg-[#EE4D2D] text-white font-bold py-3 rounded-lg hover:bg-[#D03F2A] transition-colors"
        >
          Tirar Nova Foto
        </button>
        <button
          onClick={() => navigate('/home', { state: { fromPhoto: true } })}
          className="w-full bg-white text-[#EE4D2D] font-bold py-3 rounded-lg border-2 border-[#EE4D2D] hover:bg-red-50 transition-colors"
        >
          Voltar Para Home
        </button>
      </div>
    </div>
  );
}